import { useEffect, useState } from "react";
import { FormInput } from "../Components/FormInputs/FormInputs";
import { FormDate } from "../Components/FormDate";
import { FormSelect } from "../Components/FormSelect";
import ModalPopup from "../Components/ModalPopup/ModalPopup";
import {
  AutoComplete,
  Input,
  Popover,
  Button,
  Checkbox,
  Radio,
  message,
  Tooltip,
  Space,
} from "antd";

import type { SelectProps, GetProp } from "antd";

import { FaFilter } from "react-icons/fa6";

export default function FormControls() {
  // Modal
  const [modalVisible, setModalVisible] = useState(false);

  // Multi Select Props
  const sharedProps: SelectProps = {
    mode: "multiple",
    style: { width: "100%" },
    placeholder: "Select Multiple Item...",
    maxTagCount: "responsive",
  };

  // Autocomplete
  const autocompleteoptions = [
    { value: "Burns Bay Road" },
    { value: "Downing Street" },
    { value: "Wall Street" },
  ];

  // Masked Input
  const [value, setValue] = useState("");
  const [maskedValue, setMaskedValue] = useState("");

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
  };

  useEffect(() => {
    if (value.length > 4) {
      const visibleDigits = value.slice(-4);
      const maskedPart = "*".repeat(value.length - 4);
      setMaskedValue(maskedPart + visibleDigits);
    } else {
      setMaskedValue(value);
    }
  }, [value]);
  // END Masked Input

  // Popover Content
  const content = (
    <div>
      <p>Content</p>
      <p>Content</p>
    </div>
  );

  // Checkbox options
  const checkboxOptions = ["Apple", "Pear"];
  const onCheckbox: GetProp<typeof Checkbox.Group, "onChange"> = (
    checkedValues
  ) => {
    console.log("checked = ", checkedValues);
  };

  // Radio options
  const radioOptions = [
    { value: 1, label: "Apple" },
    { value: 2, label: "Pear" },
  ];

  // Success, Error and Warning Message
  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    debugger;
    messageApi.open({
      type: "success",
      content: "This is a success message",
    });
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "This is an error message",
    });
  };

  const warning = () => {
    messageApi.open({
      type: "warning",
      content: "This is a warning message",
    });
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      {contextHolder}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="pageName">
              <h4>Form Controls</h4>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormInput
              label="Input Text"
              placeholder="Enter"
              rules={[{ required: true, message: "Please enter!" }]}
            />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormInput label="Input Text" placeholder="Enter" disabled={true} />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <Space>
              <FormInput
                label="Input Text"
                placeholder="Enter"
                rules={[{ required: true, message: "Please enter!" }]}
              />
              <Button className="btn-submit" style={{ marginTop: "12px" }}>
                Add
              </Button>
            </Space>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormDate
              label="Date Picker"
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormDate label="Date Picker" disabled={true} />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormSelect
              label="Single Select"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "yiminghe" },
              ]}
              rules={[{ required: true, message: "Please enter!" }]}
            />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormSelect
              label="Single Select"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "yiminghe" },
              ]}
              disabled={true}
            />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormSelect
              label="Multi Select"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "yiminghe" },
                { value: "Test 1", label: "Test 1" },
                { value: "Test 2", label: "Test 2" },
              ]}
              {...sharedProps}
            />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <FormSelect
              label="Multi Select"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "yiminghe" },
                { value: "Test 1", label: "Test 1" },
                { value: "Test 2", label: "Test 2" },
              ]}
              {...sharedProps}
              disabled={true}
            />
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="custom_group">
              <label htmlFor="AutoComplete">AutoComplete</label>
              <AutoComplete
                id="AutoComplete"
                style={{ width: "100%" }}
                options={autocompleteoptions}
                placeholder="try to type `b`"
                filterOption={(inputValue, option) =>
                  option!.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="custom_group">
              <label htmlFor="masked">Masked Input</label>
              <Input
                id="masked"
                type="text"
                value={maskedValue}
                onChange={handleInputChange}
                placeholder="Enter value"
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="custom_group">
              <label>Checkbox</label>
              <Checkbox.Group
                options={checkboxOptions}
                defaultValue={["Apple"]}
                onChange={onCheckbox}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="custom_group">
              <label htmlFor="radiogroup">Radio</label>
              <Radio.Group
                name="radiogroup"
                defaultValue={1}
                options={radioOptions}
              />
            </div>
          </div>
          {/* <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="custom_group">
              <label>Attachment</label>
              <Upload {...props} fileList={fileList}>
                <Button className="btn-update" icon={<UploadOutlined />}>
                  Upload
                </Button>
              </Upload>
            </div>
          </div> */}
          <div className="col-lg-12">
            <FormInput
              textArea={true}
              label="TextArea"
              placeholder="Description..."
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="d-sm-block d-md-flex gap-2 buttons">
              <Button className="btn-submit" onClick={success}>
                Submit
              </Button>
              <Button className="btn-cancel" onClick={error}>
                Cancel
              </Button>
              <Button className="btn-reset" onClick={warning}>
                Reset
              </Button>
              <Button
                className="btn-update"
                onClick={() => setModalVisible(true)}
              >
                Modal Popup
              </Button>
              <Popover content={content} title="Title" trigger="click">
                <Button className="btn-pdf">Popover Button</Button>
              </Popover>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-12">
            {toggle && (
              <div className="row" id="filterContent">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <FormSelect
                    label="Select Knowledge"
                    options={[
                      { value: "jack", label: "Jack" },
                      { value: "lucy", label: "Lucy" },
                    ]}
                    rules={[{ required: true, message: "Please select!" }]}
                  />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <FormSelect
                    label="Select Knowledge"
                    options={[
                      { value: "jack", label: "Jack" },
                      { value: "lucy", label: "Lucy" },
                    ]}
                    rules={[{ required: true, message: "Please select!" }]}
                  />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <FormSelect
                    label="Select Knowledge"
                    options={[
                      { value: "jack", label: "Jack" },
                      { value: "lucy", label: "Lucy" },
                    ]}
                    rules={[{ required: true, message: "Please select!" }]}
                  />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <FormSelect
                    label="Select Knowledge"
                    options={[
                      { value: "jack", label: "Jack" },
                      { value: "lucy", label: "Lucy" },
                    ]}
                    rules={[{ required: true, message: "Please select!" }]}
                  />
                </div>
              </div>
            )}
          </div>

          {/* <div className="col-lg-3">
            <FormSelect
              label="Select Category"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
              ]}
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3">
            <FormSelect
              label="Select Type"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
              ]}
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3">
            <FormSelect
              label="Select Knowledge"
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
              ]}
              rules={[{ required: true, message: "Please select!" }]}
            />
          </div>
          <div className="col-lg-3">
            <div className="custom_group">
              <div className="d-flex gap-2 justify-content-end">
                <Tooltip title="Advanced Filter">
                  <Button
                    className="filterBtn"
                    shape="circle"
                    color="default"
                    variant="text"
                    icon={<FaFilter />}
                    onClick={toggleFilter}
                  />
                </Tooltip>
                <Button className="btn-submit">Apply</Button>
                <Button className="btn-reset">Reset</Button>
              </div>
            </div>
          </div> */}

          {/* <div className="col-lg-12">
            <ReactQuill
              theme="snow"
              value={richValue}
              onChange={setRichValue}
            />
          </div> */}
        </div>
      </div>

      <ModalPopup
        title="Modal Heading"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        okText="Submit"
        onOk={() => setModalVisible(false)}
      >
        <p>Popup Content...</p>
        <p>Popup Content...</p>
        <p>Popup Content...</p>
      </ModalPopup>
    </>
  );
}
